var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.props.value === true)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("mdi-check-circle")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }